export enum UserStatus {
  InActive = 'InActive',
  Active = 'Active',
}
